export enum EndPoint {
  login = '/login',
  validateLogin = '/login/validate-code',
  sendRecoveringPassEmail = '/login/send-recovery-password',
  validateCodeRecoveringPasss = '/login/validate-recovery-code',
  changePassword = '/password/update-password',
  postFirstChangePassword = '/password/first-change-password',
}

export enum UserRole {
  admin = 'administrator',
  rh = 'rrhh',
  declarant = 'declarant',
  reviewer = 'reviewer',
}

export enum AuthStatus {
  authenticated = 'authenticated',
  notAuthenticated = 'not-authenticated',
  checking = 'checking',
}

export interface LoginRequestBody {
  email: string;
  password: string;
}

export interface LoginResponse {
  message: string;
  user_id: number;
}

export interface sendVerificationCodeResponse {
  message: string;
  email: string;
}

export interface VerifyCodeRequestBody {
  user_id: number;
  code: string;
}

export interface VerifyCodeResponse {
  message: string;
  token: {
    user_image: string | null;
    first_session: boolean;
    change_password: boolean;
    token: string;
    changePasswordToken?: string;
  };
}
export interface VerifyRecoveryPassCodeResponse {
  message: string;
  token?: string;
}

export interface UserInformation {
  user_id: number;
  role_id: number;
  role: string;
  role_value: string;
  institution_id: number[];
  user_name: string;
  user_lastname: string;
  user_email: string;
  user_image: string | null;
  first_seccion: boolean; // true si ya ha ingresado, false si es la primera vez
  change_password: boolean; // true si ya cambió la contraseña
}
